import React from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography, TextField } from "@material-ui/core";
import { useSnackbar } from "notistack";
import Context from "../../context";
import { postContactUs, getContactUsInfo } from "../../services";
import { Maps, InfoDetail, Icons } from "../../components";

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding: 0 16px;
  padding-bottom: 32px;
  @media screen and (max-width: 500px) {
    flex-direction: column-reverse;
  }
`;

const StyledForm = styled.form`
  max-width: 450px;
`;

const StyledBorder = styled.div`
  border-left: 1px solid #d4d4d4;
  margin-left: 80px;
  margin-right: 40px;
`;

const StyledInfo = styled.div`
  max-width: 300px;
`;

const StyledSvg = styled.a`
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  margin-right: 8px;
  border-radius: 8px;
  &:hover {
    background-color: #eeeeee;
  }
`;

const useStyles = makeStyles({
  input: {
    marginBottom: "1rem",
  },
});

const initForm = {
  fullname: "",
  email: "",
  subjek: "",
  message: "",
};

const HubungiKami = () => {
  const classes = useStyles();
  const context = React.useContext(Context);
  const [loadingButtonState, setLoadingButtonState] = React.useState(false);
  const [formState, setFormState] = React.useState(initForm);
  const [contactUs, setContactUs] = React.useState({
    desc_id: "",
    desc_en: "",
    fb: "",
    ig: "",
    tw: "",
    yt: "",
    latitude: "",
    longitude: "",
  });
  const { enqueueSnackbar } = useSnackbar();
  const currentLang = context.getLang();
  const isId = currentLang === "ID";
  const { fullname, email, subjek, message } = formState;
  const { desc_id, desc_en, fb, ig, tw, yt, latitude, longitude } = contactUs;
  const handleChange = (event: any) => {
    setFormState({ ...formState, [event.target.name]: event.target.value });
  };

  const handleAddContactUs = async (e: any) => {
    e.preventDefault();
    try {
      setLoadingButtonState(true);
      const res = await postContactUs(formState);
      setLoadingButtonState(false);
      if (res.status === "error") {
        enqueueSnackbar(res.message, {
          variant: "error",
        });
        return;
      }
      enqueueSnackbar(
        `${
          isId ? "Berhasil Mengirimkan pesan" : "Successfully Sending message"
        }`,
        {
          variant: "success",
        }
      );
      setFormState(initForm);
    } catch (err: any) {
      setLoadingButtonState(false);
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    }
  };

  const fetchContectUsInfo = async () => {
    try {
      const res = await getContactUsInfo();
      setContactUs(res.data);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    fetchContectUsInfo();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {latitude && longitude && <Maps lat={latitude} long={longitude} />}
      <StyledContainer>
        <StyledForm onSubmit={handleAddContactUs}>
          <Typography
            color="primary"
            variant="h4"
            style={{ marginBottom: "1rem" }}
            gutterBottom
          >
            {isId ? "Hubungi Kami" : "Contact Us"}
          </Typography>
          <Typography
            color="textPrimary"
            style={{ marginBottom: "2rem" }}
            gutterBottom
          >
            {isId ? desc_id : desc_en}
          </Typography>
          <TextField
            className={classes.input}
            onChange={handleChange}
            value={fullname}
            name="fullname"
            label="Fullname"
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            className={classes.input}
            onChange={handleChange}
            value={email}
            type="email"
            name="email"
            label="Email"
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            className={classes.input}
            onChange={handleChange}
            value={subjek}
            name="subjek"
            label="Subjek"
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            className={classes.input}
            onChange={handleChange}
            value={message}
            name="message"
            label="Message"
            variant="outlined"
            multiline
            rows="5"
            fullWidth
            required
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ marginTop: 16 }}
            disabled={loadingButtonState}
          >
            {loadingButtonState ? "Loading" : isId ? "Kirim" : "Send"}
          </Button>
        </StyledForm>
        <StyledBorder />
        <StyledInfo>
          <Typography
            style={{ fontWeight: 800, marginBottom: "1rem" }}
            color="textPrimary"
            gutterBottom
          >
            {isId ? "Info Detail " : "Detailed Info "}:
          </Typography>
          <InfoDetail color="#424244" colorIcon="E3232A" />
          <Typography
            style={{ fontWeight: 800, marginTop: "3rem" }}
            color="textPrimary"
            gutterBottom
          >
            {isId ? "Ikuti Kami " : "Follow Us "}:
          </Typography>
          <div style={{ display: "flex" }}>
            <StyledSvg href={ig} target="_blank">
              <Icons.IconInstagram width={20} height={20} fill="#424244" />
            </StyledSvg>
            <StyledSvg href={yt} target="_blank">
              <Icons.IconYoutube width={31} height={20} fill="#424244" />
            </StyledSvg>
            <StyledSvg href={fb} target="_blank">
              <Icons.IconFacebook width={15} height={20} fill="#424244" />
            </StyledSvg>
            <StyledSvg href={tw} target="_blank">
              <Icons.IconTwitter width={24} height={20} fill="#424244" />
            </StyledSvg>
          </div>
        </StyledInfo>
      </StyledContainer>
    </>
  );
};

export default HubungiKami;
